import { FilterDropdown } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { ReactNode, useCallback } from "react";

import type { ISegment } from "../helpers";

import { GridFiltersController } from "../api/gridFiltersController";
import { QUERY_KEYS } from "../api/queryKeys";

interface Props {
	value: number[];
	changeHandler: (value: number[], id: string) => void;
	label?: ReactNode;
	filters?: ISegment;
	id?: string;
}

export function MachinesDropdown(props: Props) {
	const { filters = {}, id = "machines", changeHandler: onChange } = props;
	const machineFilters = {
		brands: filters.brandIds,
		channels: filters.channelIds,
		marketers: filters.marketerIds,
		states: filters.stateIds,
		branches: filters.branchIds,
		showInactiveOffices: filters.showInactiveOffices,
	};

	const machinesQuery = useQuery({
		queryKey: [QUERY_KEYS.Components.MachinesDropdown, machineFilters],
		queryFn: () => GridFiltersController.getMachines(machineFilters),
	});

	const changeHandler = useCallback((v: number[]) => onChange(v, id), [onChange, id]);

	return (
		<FilterDropdown
			{...props}
			id={id}
			allOption
			values={machinesQuery.data ?? []}
			loaded={!machinesQuery.isLoading}
			changeHandler={changeHandler}
			objectName="Machines"
			fullLength
			isMulti
		/>
	);
}
